import {
    WorkflowLayerArgs,
    WorkflowLayerResponse,
    WorkflowLayerType,
} from '@form-engine/core-application/types/form';
import FormEngine from '@form-engine/core-application';
import { compile } from '@form-engine/core-util/template';
import { getFormSessionLocals } from '@form-engine/core-application/utilities/form-session';

/**
 * this is needed because the ts typechecker incorrectly errors TS2352 otherwise
 * @see https://caniuse.com/?search=canparse
 */
const { canParse } = URL as unknown as { canParse: (s: string) => boolean };

function FormEngineRedirectWfl({
    form,
    session,
    definition,
}: WorkflowLayerArgs): Promise<WorkflowLayerResponse> {
    if (definition.type !== apiName) {
        throw new Error('invalid workflow definition');
    }

    const response = Promise.resolve({ ...session });

    if (!definition.url) {
        return response;
    }

    let url = compile(definition.url, getFormSessionLocals(form, session));

    const { origin } = new URL(document.baseURI);

    if (!/^https?:\/\//i.test(url)) {
        url = `${origin}${url}`;
    }

    let valid = false;
    if (!definition.allowForeignOrigins) {
        if (canParse(url)) {
            valid = new URL(url).origin === origin;
        }
    } else {
        valid = true;
    }

    if (valid) {
        window.open(
            url,
            FormEngine.isBuilder ? '_blank' : definition.urlTarget ?? '_self'
        );
    } else {
        console?.error(`redirect url ${url} is forbidden`);
    }

    return response;
}

export const apiName = (FormEngineRedirectWfl.apiName =
    'FormEngineRedirectWfl');

export default FormEngineRedirectWfl as WorkflowLayerType;
